import {getUserInfo} from "../../utills/userUtils";
import history from "../../utills/history";

const hasPermission=(permissions,authority)=>{
    if(permissions.includes("admin")){
        return true
    }
    if(Array.isArray(authority)){
        for(let i = 0; i < authority.length; ++i){
            if(permissions.includes(authority[i])){
                return true
            }
        }
        return false
    }else {
        return permissions.includes(authority)
    }
};
const authorize = (authority)=>{
    return new Promise((resolve, reject) => {
        return getUserInfo().then((userInfo)=>{
            /*
            未登录重定向到登录界面
             */
            if(!userInfo){
                history.push("/login")
            }else if(userInfo && userInfo.permissions) {
                if (hasPermission(userInfo.permissions, authority)) {
                    resolve(true);
                } else {
                    reject(false);
                }
            }else{
                reject(false);
            }
        })
    })
};
export default authorize;